import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { App } from 'ionic-angular';
import { OauthService } from './oauth.service';
import { ToolsService } from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class ModeleEcheancierService extends OauthService {

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
  }


  /**
   * Get a list of modeles d'échéanciers
   *
   * @returns {Observable<any>}
   */
  get(consommationId: number) {
    const url = this.Routing.generate('api_get_modele_echeanciers_consommation', {
      '_format': 'json',
      'consommation': consommationId
    }, true);

    return this.http
      .get(url, { headers: this.updateHeaders() })
      .map(response => response.json().data);

  }
}



// WEBPACK FOOTER //
// ./src/shared/services/modeleEcheancier.service.ts